import React from "react";
import styled from "styled-components";
import ExportCountrySection from "../components/ExportCountrySection";
import ExportNetwork from "../components/ExportNetwork";
import { exportPageLang } from "../lang/ExportPageLang";
import { EXPORT_MAIN } from "../config/Constant";
import ExportCertificate from "../components/ExportCertificate";
import MainImgBlock from "./MainImgBlock";

const Section = styled.section`
  position: relative;
  padding: 100px 20px;
  background: linear-gradient(to bottom right, #f9f9f9, #ffffff);
  overflow: hidden;
`;

const Export = () => {
  return (
    <>
      <MainImgBlock title={exportPageLang.EXPORT} imgLink={EXPORT_MAIN} />
      <Section>
        <ExportNetwork />
      </Section>
      <ExportCountrySection />
      <ExportCertificate />
    </>
  );
};

export default Export;
